import { useContext } from 'react';

import { FeatureContext } from '@/providers/feature-provider';
import { FeatureConfig } from '@/utils/athena-feature-config';

// Overloading the function signatures for better type safety to better
// handle the different types of feature flags and their default values
export function useFeatureValue<K extends keyof FeatureConfig>(
  key: K,
  defaultValue: NonNullable<FeatureConfig[K]>,
): NonNullable<FeatureConfig[K]>;
export function useFeatureValue<K extends keyof FeatureConfig>(key: K): FeatureConfig[K];
export function useFeatureValue<K extends keyof FeatureConfig>(
  key: K,
  defaultValue?: FeatureConfig[K],
): FeatureConfig[K];
export function useFeatureValue<K extends keyof FeatureConfig>(
  key: K,
  defaultValue?: FeatureConfig[K],
): FeatureConfig[K] {
  const athenaValues = useContext(FeatureContext);
  const value = athenaValues?.[key];

  if (value !== undefined && value !== null) {
    return value;
  }

  if (defaultValue !== undefined) {
    return defaultValue;
  }

  return defaultValue;
}
